import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BlogForm from "./BlogForm";
import { getBlogById, updateBlog } from "../../api/BlogService";

const BlogEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const id = location.state?.blogId;
  const slug = location.state?.blogslug;

  const [loading, setLoading] = useState(false);
  const [blog, setBlog] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    loadBlog();
  }, [id, slug]);

  const loadBlog = async () => {
    try {
      const res = await getBlogById(slug || id);

      const data = res?.data || res;

      setBlog({
        _id: data?._id || id || "",
        title: data?.title || "",
        description:
          data?.description ||
          data?.blogDescription ||
          data?.content ||
          "",
        excerpt: data?.excerpt || "",
        category:
          data?.category?._id ||
          data?.category?.id ||
          data?.category ||
          "",
        productCategory:
          data?.productCategory?._id ||
          data?.productCategory?.id ||
          data?.productCategory ||
          "",
        author:
          data?.author?._id ||
          data?.author?.id ||
          data?.author ||
          "",
        publishedDate: data?.publishedDate || "",
        readingTime: data?.readingTime || "",
        content: data?.content || "",
        status: data?.status || "ACTIVE",

        metaTitle:
          data?.metaTitle ||
          data?.seoTitle ||
          data?.meta_title ||
          data?.seo_title ||
          data?.seo?.title ||
          data?.seo?.metaTitle ||
          data?.seo?.seoTitle ||
          data?.seo?.meta_title ||
          data?.seo?.seo_title ||
          "",

        metaDescription:
          data?.metaDescription ||
          data?.seoDescription ||
          data?.meta_description ||
          data?.seo_description ||
          data?.seo?.description ||
          data?.seo?.metaDescription ||
          data?.seo?.seoDescription ||
          data?.seo?.meta_description ||
          data?.seo?.seo_description ||
          "",

        metaKeywords: Array.isArray(data?.metaKeywords)
          ? data.metaKeywords.join(", ")
          : Array.isArray(data?.meta_keywords)
            ? data.meta_keywords.join(", ")
            : Array.isArray(data?.seo?.metaKeywords)
              ? data.seo.metaKeywords.join(", ")
              : Array.isArray(data?.seo?.keywords)
                ? data.seo.keywords.join(", ")
                : (
                    data?.metaKeywords ||
                    data?.meta_keywords ||
                    data?.seo?.metaKeywords ||
                    data?.seo?.keywords ||
                    ""
                  )
                    .toString()
                    .trim(),

        metaImage:
          data?.metaImage ||
          data?.metaImageUrl ||
          data?.meta_image ||
          data?.meta_image_url ||
          data?.seo?.image ||
          data?.seo?.metaImage ||
          data?.seo?.meta_image ||
          data?.seo?.imageUrl ||
          data?.seo?.metaImageUrl ||
          null,

        metaImagePreview:
          data?.metaImage ||
          data?.metaImageUrl ||
          data?.meta_image ||
          data?.meta_image_url ||
          data?.seo?.image ||
          data?.seo?.metaImage ||
          data?.seo?.meta_image ||
          data?.seo?.imageUrl ||
          data?.seo?.metaImageUrl ||
          null,
      });
    } catch (error) {
      console.error("Get Blog Error", error);

      setErrors({
        message:
          error?.response?.data?.message ||
          error?.message ||
          "Failed to load blog",
      });
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      setErrors({});

      const payload = {
        title: values.title,
        blogDescription: values.description,
        excerpt: values.excerpt,

        category: values.category,
        productCategory: values.productCategory,

        author: values.author,
        publishedDate: values.publishedDate,
        readingTime: Number(values.readingTime),
        content: values.content,
        status: values.status,
        metaImage: values.metaImage,
      };

      const blogId = id || blog?._id || location.state?.blogId;

      if (!blogId) {
        const missingBlogIdError = {
          message:
            "Unable to update the blog because the blog ID could not be resolved.",
        };

        setErrors(missingBlogIdError);

        return {
          success: false,
          error: missingBlogIdError,
        };
      }

      // Update Blog
      const res = await updateBlog(blogId, payload);

      console.log("UPDATE BLOG RESPONSE:", res);

      if (!res?.success) {
        const error =
          res?.error ||
          res?.data?.error ||
          res?.data?.errors ||
          res?.errors || {
            message: "Blog update failed",
          };

        setErrors(error);

        return {
          success: false,
          error,
        };
      }

      return {
        success: true,
        data: res?.data,
      };
    } catch (error) {
      console.error("UPDATE ERROR", error);

      const responseError =
        error?.response?.data?.error ||
        error?.response?.data?.errors ||
        error?.response?.data || {
          message: error?.message || "Update failed",
        };

      setErrors(responseError);

      return {
        success: false,
        error: responseError,
      };
    } finally {
      setLoading(false);
    }
  };

  if (!blog) {
    return <p>Loading...</p>;
  }

  return (
    <BlogForm
      blog={blog}
      initialValues={blog}
      onSubmit={handleSubmit}
      loading={loading}
      errors={errors}
      onSuccess={() => navigate("/blog")}
      onCancel={() => navigate("/blog")}
    />
  );
};

export default BlogEdit;